import React from 'react'
import Logo from '../assets/logo.png';
import { ImFacebook } from 'react-icons/im';
import { FaInstagram } from 'react-icons/fa';
import { FaLocationDot } from 'react-icons/fa6';
import { IoCall, IoMailUnread } from 'react-icons/io5';
import { useNavigate } from 'react-router-dom';
import { BsWhatsapp } from "react-icons/bs";

const Footer = () => {
  const navigate = useNavigate();


  return (
    <>
    <section className='footer-bg py-4'>
<div className='container'>
<div className='row m-0'>


{/* <div className='col-lg-8 col-12 mt-2 p-0'> */}
{/* <div className='footer-left p-5'> */}

{/* <div className='row'> */}
<div className='col-lg-5 col-12 text-start'>
<img src={Logo} className='img-fluid' style={{height: '7em'}} />
<p className='fm-inter fw-bold fs-5 text-light'>Trade <span className='fw-bolder'>Intell</span></p>
<p className='para-text text-light'>Educating new and experienced traders with actionable insights for smarter decisions.
Build consistency and discipline that transforms trades into long-term strategies.</p>

<BsWhatsapp onClick={() => window.open('https://wa.me/+918018532612')} className='nav-area-icon text-light me-2' size={36} />
<FaInstagram onClick={() => window.open('https://www.instagram.com/tradeintell?igsh=bXFnYzR0MmZ2aG8w', '_blank')} className='nav-area-icon text-light' size={36} />

</div>

<div className='col-lg-4 col-12'>
  <p className='fw-semibold text-light fm-inter'>Useful Links</p>
  <p className='para-text text-light'>Build informed decisions into every move & develop discipline that turns trading into strategy, not gamble.</p>
  <p className='nav-area-btn text-light' onClick={() => navigate('/')}>Home</p>
<p className='nav-area-btn text-light' onClick={() => navigate('/about')}>About Us</p>
<p className='nav-area-btn text-light' onClick={() => navigate('/privacy-policy')}>Privacy Policy</p>
<p className='nav-area-btn text-light' onClick={() => navigate('/contact')}>Contact</p>

</div>

{/* </div> */}
{/* inner row ends */}
{/* </div> */}
{/* </div> */}


<div className='col-lg-3 col-12 my-4'>
    <p className='fw-semibold fm-inter text-light'>Contact Us</p>
<p className='fw-semibold bg-white rounded p-2'><FaLocationDot /> Hinjilicut, Odisha (761102)</p>
<p className='fw-semibold bg-white rounded p-2'><IoCall /> +91 8018532612</p>
<p className='fw-semibold bg-white rounded p-2'><IoMailUnread /> info@intell.com</p>
</div>



</div>
{/* row ends */}

<hr className='text-light' />
<p className='fw-semibold text-light' onClick={() => window.open('https://www.digithack.in/', '_blank')}>Copyright &copy; Trade Craft. Developed by Digit Hack Software Solutions</p>
</div>
      </section>

<div className='global-btn-area animate__animated animate__headShake animate__infinite animate__slow'>
      <button className='global-btn text-start'>Free Trial<br />3 Days</button>
      </div>
    </>
  )
}

export default Footer